<template>
  <BTableSimple
    v-bind="$attrs"
    :headers="headers"
    :actions="filteredActions"
    v-on="$listeners"
  >
    <template #item.user.username="{ header, data, value: v }">
      <router-link
        v-if="!!header.getRoute"
        class="BTablePublicationFormdata__link"
        :to="header.getRoute(data)"
        v-text="v"
      />
      <span v-else v-text="v" />
    </template>

    <template #item.status_icon="{ data }">
      <v-tooltip
        v-if="(!data.disabled && !['overdue', 'close'].includes(data.status)) ||
          (data.disabled && data.status === 'again_opened')
        "
        top
      >
        <template #activator="{ on }">
          <v-icon
            color="success"
            size="16px"
            class="mr-2"
            v-on="on"
            v-text="'mdi-checkbox-marked-outline'"
          />
        </template>
        <slot>
          <span>Отчет доступен для заполнения</span>
        </slot>
      </v-tooltip>

      <v-tooltip v-else top>
        <template #activator="{ on }">
          <v-icon
            color="error"
            size="16px"
            class="mr-2"
            v-on="on"
            v-text="'mdi-close-circle-outline'"
          />
        </template>
        <slot>
          <span>Отчет недоступен для заполнения</span>
        </slot>
      </v-tooltip>
    </template>

    <template #item.status="{ header, data }">
      <span>{{ header.field(data.status, data.is_submitted) }}</span>
    </template>

    <template #item.data_collection.name="{ header, data, value: v }">
      <router-link
        v-if="!!header.getRoute"
        class="BTablePublicationFormdata__link"
        :to="header.getRoute(data)"
        v-text="v"
      />
      <span v-else v-text="v" />
    </template>
  </BTableSimple>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_ACTIONS_ADMIN,
  TABLE_HEADERS,
} from '@/views/FormData/table-headers'
import BTableSimple from './BTableSimple.vue'
import { rootMapper } from '@/store/modules/root'


export default {
  name: 'BTableFormData',
  components: {
    BTableSimple,
  },
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    formdataDisabled: Boolean,
  },
  computed: {
    ...rootMapper.mapGetters(['profile']),
    filteredActions() {
      return this.profile.is_admin ? TABLE_ACTIONS_ADMIN : this.actions
    },
  },
}
</script>
